import React, { useEffect, useState } from "react";
import {
	Row,
	Col,
	CardTitle,
	Label,
	CardBody,
	CardHeader,
	Form,
	CardText,
	Button,
} from "reactstrap";
import NumberSelector from "features/inventory/subFeatures/selector/NumberSelector";
import FinanceTermInput from "../finance/FinanceTermInput";
import useCurrentSaleStore from "stores/SaleStore";
import RollModalBody from "./RollModalBody";
import useCurrentDealStore from "stores/DealStore";
import { DealStatus, LoanPeriod } from "constants/Constants";
import PaymentOptionsModal from "./PaymentOptionsModal";
import ChildrenModal from "components/modals/ChildrenModal";
import OpenModal from "./OpenModal";
import formNavigationUtils from "utils/formNavigationUtils";
import NumberFormat from "react-number-format";
import useCurrentRecapStore from "stores/RecapStore";
import shallow from "zustand/shallow";
import { confirmDeleteMessage } from "utils/alertUtils";
import BalloonModalBody from "./BalloonModalBody";
import FinanceDaysToPayInput from "../finance/FinanceDaysToPayInput";
import OpenModalButton from "features/deal/components/OpenModalButton";
import MenuSelling from "./MenuSelling";
import ResidualInput from "../lease/ResidualInput";
import MoneyFacInput from "../lease/MoneyFacInput";
import useCurrentLeaseStore from "../../../../stores/LeaseStore";
import MarkupInput from "../lease/MarkupInput";
import LeaseAprInput from "../lease/LeaseAprInput";

/**
 * TermsTable component to display the terms and payment options.
 *
 * @returns {JSX.Element} The rendered component
 */
const LeaseTerms = () => {
	const [showProfit, setShowProfit] = useState(false);
	const [paymentOptions, setPaymentOptions] = useState(false);

	const toggle = () => setShowProfit(!showProfit);
	const togglePayment = () => setPaymentOptions(!paymentOptions);

	const {
		leasePeriod,
		daysToPay,
		firstDueDate,
		loanDate,
		term,
		residualFactor,
		leaseType,
		editField,
	} = useCurrentLeaseStore(
		(state) => ({
			...state,
			apr: state.apr,
		}),
		shallow
	);
	console.log(residualFactor);
	// const lease = useCurrentLeaseStore((state) => ({ ...state }), shallow);

	const { netProfit } = useCurrentRecapStore((state) => state, shallow);

	const { type, dealId } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
			dealId: state.deal.ID,
		}),
		shallow
	);

	const [menuSelling, setMenuSelling] = useState(false);
	const toggleSelling = () => setMenuSelling(!menuSelling);

	return (
		<>
			<CardHeader>
				<CardTitle tag="h3">Payments</CardTitle>
			</CardHeader>
			<CardBody className="pb-0" onKeyDown={formNavigationUtils}>
				<Form className="deal-terms-table">
					<Row className="mx-0">
						<Col xl="5" className="mb-2">
							<Label className="">Period</Label>
							<NumberSelector
								name="dealLoanPeriod"
								readOnly={type !== DealStatus.PENDING}
								value={leasePeriod}
								selectedOption={leasePeriod}
								handleChange={(e) => editField("leasePeriod", e)}
								selectType={"loanPeriod"}
								default={true}
							/>
						</Col>
						<Col xl="3" className="mb-2">
							<Label>Term</Label>
							<FinanceTermInput
								loanPeriod={leasePeriod}
								term={term}
								editTerm={(e) => editField("term", e)}
							/>
						</Col>
						<Col xl="3" className="mb-2">
							<LeaseAprInput />
						</Col>
						{leaseType === 5 && (
							<Col xl="3" className="mb-2">
								<MoneyFacInput />
							</Col>
						)}

						<Col xl="3" className="mb-2">
							<Label>Days to 1st Pmt</Label>
							<FinanceDaysToPayInput
								loanPeriod={leasePeriod}
								daysToPay={daysToPay}
								editDaysToPay={(e) => editField("daysToPay", e)}
								firstDueDate={firstDueDate}
								loanDate={loanDate}
								type={type}
								dealId={dealId}
							/>
						</Col>
						{leaseType === 5 && <Col xl="3" className="mb-2"></Col>}
						{leaseType === 6 && <MarkupInput />}

						<ResidualInput />
					</Row>

					{/* {(bankFee > 0 || taxType === 1) && (
						<Row>
							<Col xl="4" className="mb-2">
								<Label>Adj APR (%)</Label>
								<AdjustmentAPR />
							</Col>
							{bankFee > 0 && (
								<Col xl="6" className="mb-2">
									<Label>Prepaid Finance Charge</Label>
									<PrepaidFinanceCharge />
								</Col>
							)}
						</Row>
					)} */}

					<hr className="my-2" />

					<Row className="px-2">
						{/* <Col xl="6">
							<BalloonButton />
						</Col> */}
						{/* <Col xl="6">
							<RollButton />
						</Col> */}
					</Row>

					<Col className="p-0">
						<Row className="mb-3">
							<Col xs="6" className="d-flex justify-content-start">
								<Button className="brn-sm" color="primary" onClick={toggle}>
									Roll By Payment
								</Button>

								{/* <OpenModalButton
									buttonText="Payment Options"
									onClick={togglePayment}
									iconClass="nc-icon nc-refresh-69"
									buttonClass="btn btn-sm btn-primary mx-auto"
								/>
								<ChildrenModal
									modalTitle="Payment Options"
									modal={paymentOptions}
									toggle={togglePayment}
									size="lg"
								>
									<PaymentOptionsModal toggle={togglePayment} />
								</ChildrenModal> */}
							</Col>
							<Col xs="6" className="d-flex justify-content-end">
								<Button className="brn-sm" color="primary" onClick={toggle}>
									Roll By DriveOff
								</Button>
								{/* <OpenModalButton
									buttonText="Menu Selling"
									onClick={toggleSelling}
									iconClass="nc-icon nc-refresh-69"
									className="btn btn-lg btn-primary"
								/>
								<ChildrenModal
									modalTitle="Menu Selling"
									modal={menuSelling}
									toggle={toggleSelling}
									size="lg"
								>
									<MenuSelling toggle={toggleSelling} />
								</ChildrenModal> */}
							</Col>
						</Row>
					</Col>
				</Form>
			</CardBody>
		</>
	);
};

export default LeaseTerms;

/**
 * RollButton component to handle the roll back functionality.
 *
 * @returns {JSX.Element} The rendered component
 */
const RollButton = () => {
	const {
		rollBack,
		editPrice,
		rollPreValue,
		editRollPreValue,
		editRollBack,
		editTerm,
		editApr,
		editDown,
	} = useCurrentSaleStore((state) => state, shallow);

	const { type } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
		}),
		shallow
	);

	const confirmRollBack = () => {
		confirmDeleteMessage("Roll deal back?").then((res) => {
			if (res === "Roll deal back?") {
				handleRollBack();
			}
		});
	};

	const handleRollBack = () => {
		console.log(rollBack);
		console.log(Number.parseInt(rollBack));
		switch (Number.parseInt(rollBack)) {
			case 10:
				editPrice(rollPreValue);
				break;
			case 20:
				editDown(rollPreValue);
				break;
			case 40:
				editApr(rollPreValue);
				break;
			case 90:
				console.log(rollPreValue);
				editTerm(rollPreValue);
				break;
			default:
				console.log("default" + rollPreValue);
				break;
		}
		editRollPreValue(0);
		editRollBack(0);
	};

	return rollBack === 0 || rollBack === null ? (
		<OpenModal
			BodyComponent={RollModalBody}
			className="btn w-100 btn-md btn-primary"
			buttonText="Roll"
			size="lg"
		/>
	) : (
		<Button
			readOnly={type !== DealStatus.PENDING}
			onClick={confirmRollBack}
			className="btn w-100 btn-md btn-primary"
		>
			Rollback
		</Button>
	);
};
/**
 * BalloonButton component to handle the balloon functionality.
 *
 * @returns {JSX.Element} The rendered component
 */
const BalloonButton = () => {
	const { hasBalloon, editHasBalloon, editBalloonTerm, term } =
		useCurrentSaleStore((state) => state, shallow);

	const { type } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
		}),
		shallow
	);

	const confirmBalloonBack = () => {
		confirmDeleteMessage("Cancel balloon?").then((res) => {
			if (res === "Cancel balloon?") {
				editHasBalloon(false);
				editBalloonTerm(term);
			}
		});
	};

	return hasBalloon === false || hasBalloon === null ? (
		<OpenModal
			BodyComponent={BalloonModalBody}
			className="btn w-100 btn-md btn-primary"
			buttonText="Balloon"
			readOnly={term === 1}
		/>
	) : (
		<Button
			readOnly={type !== DealStatus.PENDING}
			onClick={confirmBalloonBack}
			className="btn w-100 btn-md btn-primary"
		>
			Undo Balloon
		</Button>
	);
};
